// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__k-IHY","info":"Panel_info__pqrH7","note":"Panel_note__hh-jr","close":"Panel_close__3LUYO","btns":"Panel_btns__Rq8SG","button":"Panel_button__2KvEK"};